import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { TagModel } from '../core/models/api/tag.model';


@Injectable({
  providedIn: 'root',
})
export class TagService {
  apiUrl: string = environment.backend.baseUrl + "/tag";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {}

  getTags(): Observable<TagModel[]> {
    return this.http.get<TagModel[]>(this.apiUrl);
  }

  createTag(tagData: { categoriaTagId: number; codice: string; ordineVisualizzazione?: number | null }): Observable<TagModel> {
    return this.http.post<TagModel>(this.apiUrl, tagData).pipe(
      tap(() => this.logger.info('[TAG-SERVICE] Tag creato con successo')),
      catchError(error => {
        this.logger.error('[TAG-SERVICE] Errore nella creazione del tag:', error);
        throw error;
      })
    );
  }

  deleteTag(tagId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${tagId}`).pipe(
      tap(() => this.logger.info('[TAG-SERVICE] Tag eliminato con successo')),
      catchError(error => {
        this.logger.error('[TAG-SERVICE] Errore nell\'eliminazione del tag:', error);
        throw error;
      })
    );
  }

}
